__turbopack_context__.v({
  "expandable-card": "AcfExpandableCard-module-scss-module__qy1roW__expandable-card",
  "expandable-card-body-text": "AcfExpandableCard-module-scss-module__qy1roW__expandable-card-body-text",
  "expandable-card-header": "AcfExpandableCard-module-scss-module__qy1roW__expandable-card-header",
  "expandable-card-image": "AcfExpandableCard-module-scss-module__qy1roW__expandable-card-image",
  "expandable-card-item": "AcfExpandableCard-module-scss-module__qy1roW__expandable-card-item",
});
